import { render, staticRenderFns } from "./TipPersonnel.vue?vue&type=template&id=f4a15a20&scoped=true"
import script from "./TipPersonnel.vue?vue&type=script&lang=js"
export * from "./TipPersonnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a15a20",
  null
  
)

export default component.exports